module.exports = __webpack_public_path__ + "img/img_7.cbc23d4d.jpeg";